<template>
  <v-container>
    <h2>
      パスワード変更
    </h2>
    <validation-observer ref="DriverUserFormValidator">
      <v-form>
        <v-card flat class="rounded-card">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6" offset-md="3">
                <!-- パスワード -->
                <v-row>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|password"
                      vid="password"
                      name="パスワード"
                    >
                      <v-text-field
                        v-model="user.password"
                        :error-messages="errors"
                        :type="showPassword ? 'text' : 'password'"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        dense
                        hide-details="auto"
                        label="パスワード"
                        autocomplete="new-password"
                        outlined
                        persistent-placeholder
                        @click:append="showPassword = !showPassword"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      :rules="{ required: user.password !== user.password_confirmation, confirmed: 'password' }"
                      name="パスワード（確認用）"
                    >
                      <v-text-field
                        v-model="user.password_confirmation"
                        :error-messages="errors"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        autocomplete="new-password"
                        dense
                        hide-details="auto"
                        label="パスワード（確認用）"
                        outlined
                        required
                        persistent-placeholder
                        @click:append="showConfirmPassword = !showConfirmPassword"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- /パスワード -->
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text>
            <v-row
              align="center"
              justify="center"
              class="fill-height"
            >
              <v-card outlined>
                <v-card-text>
                  <div class="subtitle-2">
                    半角8~12文字 英小文字・大文字・数字をそれぞれ1種類以上
                  </div>
                </v-card-text>
              </v-card>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </v-container>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  name: 'DriverUserForm',
  components: {},
  mixins: [],
  data () {
    return {
      showPassword: false,
      showConfirmPassword: false,
      user: {
        password: null,
        password_confirmation: null,
      },
    }
  },
  created() {
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isJwMode: 'use_jw_mode',
    })
  },
  methods: {
    ...mapActions('DriverInitialPassword', {
      updateInitialPassword: 'update'
    }),
    registerButtonClickEvent () {
      let $self = this
      this.$refs.DriverUserFormValidator.validate().then((result) => {
        if (result) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation () {
      if (this.isJwMode) {
        this.updateInitialPassword({ params: this.user }).then(() => {
          this.$router.push( { name: 'DriverManifestManagements' } )
        })
      } else {
        this.updateInitialPassword({ params: this.user }).then(() => {
          this.$router.push( { name: 'DriverDashboard' } )
        })
      }
    }
  }
}
</script>
